export default __webpack_public_path__ + "static/media/img-07-mini.d216e7e9.png";